import { useEffect, useContext, useState } from "react";
import UserContext from "../../contexts/UserContext";
import Utils from "../../Utils";
import axios from "axios";

const HrFirstLogin = (props) => {

  const { logout, userData } = useContext(UserContext);

  const LogOut = (e) => {
    e.preventDefault();
    logout(() => {
      window.location.href = process.env.PUBLIC_URL + "/";
    });
  };

  const [countries, setCountries] = useState([]);
  const [brands, setBrands] = useState([]);
  const [frmMess, setFrmMess] = useState({status: false, msg: ''});

  /* Getting list of countries */
  useEffect(() => {
    axios
      .get(Utils.apiUrl("countries?limit=200"), Utils.apiHeaders())
      .then((res) => {
        console.log(res.data);
        if(res.data.success) {
          setCountries(res.data.data);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  /* Getting list of brands */
  useEffect(() => {
    axios
      .get(Utils.apiUrl("brands?limit=99999"), Utils.apiHeaders())
      .then((res) => {
        console.log(res.data);
        if(res.data.success) {
          setBrands(res.data.data);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  /* Submitting Brand Details  */
  const submitBrandDetails = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();

    const data = {
      brand_id: frm.brand_id.value,
      name: frm.name.value,
      marsha: frm.marsha.value,
      country_id: frm.country_id.value,
    };
    //console.log(data);

    if(data.brand_id == '' || data.brand_id == 'Select Brand') {setFrmMess({status: true, msg: 'Select Brand'});}
    else if(data.name == '') {setFrmMess({status: true, msg: 'Enter Hotel Name'});}
    else if(data.marsha == '') {setFrmMess({status: true, msg: 'Enter Marsha Code'});}
    else if(data.country_id == '' || data.country_id == 'Select Country') {setFrmMess({status: true, msg: 'Select Country'});}
    else {
      axios
        .post(Utils.apiUrl(`hr/attach`), data, Utils.apiHeaders())
        .then((res) => {
          console.log(res.data);
          if(res.data.success) {
            setFrmMess({status: false, msg: ''});
            Utils.setUserData({
              token: res.data.token,
              userData: res.data.userData,
            });
            window.location.href = process.env.PUBLIC_URL + "/hotel-representative-dashboard";
          }
          else {
            setFrmMess({status: true, msg: res.data.message});
          }
          //console.log(frmMess);
        })
        .catch((err) => {
          //callback(false, err.message);
        });
    }
  }

  return (
    <>
      <header className="bg-white shadow-md py-4 px-8 flex justify-between items-center header">
          <div className="text-2xl font-bold text-gray-800"><img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Marriott Bonvoy" className="logo" /></div>
          <nav>
            <ul class="flex space-x-6">
                <li><a href="#" onClick={LogOut} class="text-gray-600 hover:text-blue-500">Logout</a></li>
            </ul>
        </nav>
      </header>
      <div className="flex items-center justify-center" style={{minHeight: 'calc(100vh - 68px)'}}>
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-xl">
        <h2 className="text-2xl font-bold text-center mb-6">Hotel Representative Details</h2>

        {frmMess.status == true && 
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 text-sm rounded relative mb-4" role="alert">
            <span className="block sm:inline">{frmMess.msg}</span>
          </div>
        }

        <form method="get" action="hotel-representative-dashboard" onSubmit={submitBrandDetails}>
          <div className="mb-4">
            <label for="brand_id" className="block text-gray-700 text-sm font-bold mb-2">Brand:</label>
            <select id="brand_id" name="brand_id" className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
              <option disabled="" selected="">Select Brand</option>
              {brands.map((brand) => (
                <option key={brand.id} value={brand.id}>{brand.name}</option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label for="name" className="block text-gray-700 text-sm font-bold mb-2">Hotel Name:</label>
            <input type="text" id="name" name="name" className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Enter Hotel Name" />
          </div>
          <div className="mb-4">
            <label for="marsha" className="block text-gray-700 text-sm font-bold mb-2">Marsha Code:</label>
            <input type="text" id="marsha" name="marsha" className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Enter Marsha Code" />
          </div>
          <div className="mb-6">
            <label for="country_id" className="block text-gray-700 text-sm font-bold mb-2">Country:</label>
            <select id="country_id" name="country_id" className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
              <option disabled="" selected="">Select Country</option>
              {countries.map((country) => (
                <option key={country.id} value={country.id}>{country.name}</option>
              ))}
            </select>
          </div>
          <div className="flex items-center justify-center">
            <button type="submit" className="btn text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full">
              Submit
            </button>
          </div>
        </form>
      </div>
      </div>
    </>
  );
};

export default HrFirstLogin;
